import React from "react";
import Routes from "./Routes";
import { CompanyProvider } from './contexts/CompanyContext';

function App() {
  return (
    <CompanyProvider>
      <Routes />
    </CompanyProvider>
  );
}

export default App;